import Icon from '../components/Icon.vue'

Icon.register({
  screwdriver: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M448 0l64 64-96 128h-62.1l-83 83c-4.3-6.8-9.1-13.3-14.9-19.1-5.8-5.8-12.3-10.6-19.1-14.9l83-83v-62.1zM128 278.6c29.1-29.1 76.3-29.1 105.4 0 29.1 29.1 29.1 76.3 0 105.4l-117.1 117.1c-14.6 14.6-38.2 14.6-52.7 0l-52.7-52.7c-14.5-14.6-14.5-38.2 0-52.7z'
      }
    ]
  }
})
